import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Desktop, Mobile } from '../../App';
import { DASHBOARD } from '../../routes/routes';
import { H1, H2, P1, P2 } from '../../styles/FontStyles';
import { Button } from '../../styles/GlobalComponents';

export const View = styled.div`
  margin-top: 70px;
  width: 100%;
  min-height: calc(100vh - 365px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const PageError = () => {
  return (
    <View>
      <Desktop>
        <H1 mb='20' center>
          Sorry, we couldn’t find that page
        </H1>
        <P1 mb='50' center>
          Try returning back to dashboard
        </P1>
      </Desktop>

      <Mobile>
        <H2 mb='20' center>
          Sorry, we couldn’t find that page
        </H2>
        <P2 mb='50' center>
          Try returning back to dashboard
        </P2>
      </Mobile>

      <Link to={DASHBOARD}>
        <Button maxWidth='300px' w='100%'>
          Go back to dashboard
        </Button>
      </Link>
    </View>
  );
};

export default PageError;
